import { Inject, Injectable } from '@angular/core';
// import { AngularFireAuth } from '@angular/fire/auth';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import Cookie from "js-cookie";
import { API_AUTH_URL, PROD_TOKEN } from '../tokens/tokens';

interface LsAuthUser {
    all_clients: "Y" | 'N';
    clients: ['ALL'] | string[];
    exp: number;
    iat: number;
    role: number;
    role_id: number;
    uid: string;
    user_id: string;
    isDiy: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    // Move this into angular environment vars
    static TOKEN_NAME: string = 'ls_auth_token';

    private _auth: BehaviorSubject<LsAuthUser>;
    private TOKEN: string;

    private _redirectUrl: string;

    private jwtHelper: JwtHelperService = new JwtHelperService();
    private DOMAIN: string;

    // TODO: Adding type infor to this

    constructor(
        // private fbAuth: AngularFireAuth,
        private http: HttpClient,
        @Inject(PROD_TOKEN) public prod: boolean,
        @Inject(API_AUTH_URL) private authURL: string,
    ) {
        // FIXME: This is why it is not logging out in production. Lack there of.
        if (prod) {
            this.DOMAIN = '.linescale.dev';
            // domain = '.h2delta.com';
        } else {
            this.DOMAIN = location.hostname;
        }
        const accessToken: string = Cookie.get(AuthService.TOKEN_NAME);
        let isTokenValid: boolean = true;

        // console.log(authURL);

        if (this.jwtHelper.isTokenExpired(accessToken)) {
            console.log('JWT expired');

            Cookie.remove(AuthService.TOKEN_NAME);
            isTokenValid = false;
            this.TOKEN = null;
        } else {
            this.TOKEN = accessToken;
        }
        this._auth = new BehaviorSubject(isTokenValid ? this.jwtHelper.decodeToken(accessToken) : null);
        console.log(this.TOKEN);
        
    }

    get redirectUrl(): string {
        const url = sessionStorage.getItem('redirectUrl');
        if (url) {
            return url;
        }
        return '/';
    }

    set redirectUrl(url: string) {
        sessionStorage.setItem('redirectUrl', url);
    }

    get token(): string {
        return this.TOKEN;
    }

    get expiration(): Date {
        return this.jwtHelper.getTokenExpirationDate(this.token);
    }

    get auth$() {
        return this._auth.asObservable();
    }

  internalSignInWithFirebase(fbToken: string) {
    return this.http.post<{ ls_jwt_token: string }>(`${this.authURL}/login/diy`, {
      token: fbToken
    }).pipe(
      tap(result => {
        let domain: string = this.DOMAIN;
        this._auth.next(this.jwtHelper.decodeToken(result.ls_jwt_token));
        if (this._auth.value)
          this.storeSession(result.ls_jwt_token, domain, new Date(this._auth.value.exp * 1000));
      })
    );
  }

    login(username: string, password: string, prod: boolean = false) {
        return this.http.post<{
            ls_jwt_token: string
            // TODO: Change this to use an injectable in the future
        }>(`${this.authURL}/login`, {
            user_id: username,
            password
        }).pipe(
            tap(result => {
                let domain: string = this.DOMAIN;
                if (prod) {
                    domain = '.linescale.com';
                    // domain = '.h2delta.com';
                }
                console.log(prod, domain);
                
                this._auth.next(this.jwtHelper.decodeToken(result.ls_jwt_token));
                this.storeSession(result.ls_jwt_token, domain, new Date(this._auth.value.exp * 1000));
            })
        );
    }

  getFirebaseToken() {
    return this.http.post<{ token: string }>(`${this.authURL}/authenticate`, { token: this.token });
  }

    externalLogin(token: string) {
      this._auth.next(this.jwtHelper.decodeToken(token));
      this.storeSession(token, this.DOMAIN || '.linescale', new Date(this._auth.value.exp * 1000));
    }

    signOut(): void {
        Cookie.remove(AuthService.TOKEN_NAME, { domain: this.DOMAIN });
        this._auth.next(null);
        this.TOKEN = null;
    }

    get auth() {
        return this._auth.getValue();
    }

    get isTokenExpired(): boolean {
        return this.jwtHelper.isTokenExpired(this.token);
    }

    /**
     * @description Store token and expiration in local storage.
     * @param token JWT token string
     * @param expiration Expiration in number of days
     */
    storeSession(token: string, domain: string, expiration: number | Date): void {
        console.log('Cook set for:', domain);
        
        Cookie.set('ls_auth_token', token, { domain, expires: expiration, sameSite: 'strict' , secure: true });
        this.TOKEN = token;
    }

}
